













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ChecklistElement, ElementStatus} from "@/models/checklistElement";
import {MaintenanceElementStatus, MaintenanceListElementEntry} from "@/models/maintenanceListElementEntry";

@Component({})
export default class MaintenanceListRadioComponent extends Vue {

  @Prop({default: new MaintenanceListElementEntry({})})
  public element!: MaintenanceListElementEntry

  public status?: MaintenanceElementStatus | null = null;

  public radioOptions: Array<{
    status: MaintenanceElementStatus,
    text: string
  }> = [{
    status: MaintenanceElementStatus.checkOkay, text: 'i.o.'
  }, {
    status: MaintenanceElementStatus.checkNotOkay, text: 'n.i.o',
  }, {
    status: MaintenanceElementStatus.notRequired, text: 'n.v'
  }];

  @Watch('element', { immediate: true })
  public elementChanged() {
    if (this.element) {
      this.status = this.element.controlStatus;
    }
  }

  public onChange() {
    this.$emit('changed', this.status);
  }
}

